import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import CarrierList from '#app/View/InventoryManagement/PreparerManager/components/CarrierList';
import OrderList from '#app/View/InventoryManagement/PreparerManager/components/OrderList';
import PreparerList from '#app/View/InventoryManagement/PreparerManager/components/PreparerList';

const PreparerManager: React.FC = () => (
  <ContentViewComponent
    breadcrumbs={{
      title: 'Manager préparateur de commande',
      context: 'Gestion des stocks',
    }}
  >
    <PreparerList />
    <CarrierList />
    <OrderList />
  </ContentViewComponent>
);

export default PreparerManager;
